import {
  Avatar,
  AvatarTypeMap,
  Badge,
  BadgeTypeMap,
  Box,
  Button,
  Link,
  SxProps,
  Theme,
  Typography,
} from '@mui/material';
import * as React from 'react';

import { TooltippedTruncatedText } from '~/components/TooltippedTruncatedText';
import { mergeSxProps } from '~/utils/helpers/sxProps';

import { useSxStyles } from './useStyles';

export interface Props {
  avatarProps: AvatarTypeMap['props'];
  badgeProps: BadgeTypeMap['props'];
  primaryText: string | JSX.Element;
  secondaryText?: string | JSX.Element;
  href?: string;
  onClick?: () => void;
  sx?: SxProps<Theme>;
}

export const BadgeItem: React.FC<Props> = (props) => {
  const {
    avatarProps,
    badgeProps,
    primaryText,
    secondaryText,
    href,
    onClick,
    sx,
  } = props;
  const sxStyles = useSxStyles();

  return (
    <Link
      component={onClick || href ? Button : 'div'}
      sx={sxStyles.root}
      href={href}
      onClick={onClick}
    >
      <Box sx={mergeSxProps(sxStyles.container, sx)}>
        <Badge
          {...badgeProps}
          sx={sxStyles.badge}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
          }}
          data-cy="badge"
        >
          <Avatar {...avatarProps} sx={sxStyles.avatar} data-cy="profile-pic" />
        </Badge>
        <Typography variant="body2" sx={sxStyles.typography} data-cy="primary">
          <TooltippedTruncatedText>{primaryText}</TooltippedTruncatedText>
        </Typography>
        {secondaryText && (
          <Typography
            variant="body2"
            sx={sxStyles.typography}
            data-cy="secondary"
          >
            <TooltippedTruncatedText>{secondaryText}</TooltippedTruncatedText>
          </Typography>
        )}
      </Box>
    </Link>
  );
};
